import './init_Jquery';
import Rails from '@rails/ujs';
import 'jquery-ui/dist/jquery-ui.min';
import 'bootstrapV5/dist/js/bootstrap.bundle.min';
import './parallax.min';
import './jquery.animateNumber.min';
import './jquery.stickr.min';
import './slick.min';
import './channels/cable';
import './counterup.min';
import './jquery.waypoints.min';
import toastr from 'toastr';
import './autonumeric.min.js';
import 'intl-tel-input/build/js/intlTelInput-jquery.min';
import './init-tel-input';
import './users/bank_account';
import './users/beneficial_owners';
import './users/company_country_input';
import './users/user_country_input';
import './users/credit_card_commission';
import './users/fiscal_form';
import './users/kyc_disclaimer';
import './users/proof_of_address';
import './users/send_notifications_to_admin';
import './display_modals';
import './close_modal';
import './tooltips';
import './document_name';
import './forms';
import './number_input_scroll_prevention';

// LIBRARIES CONFIGURATION
import './select2_init';

// STIMULUS
import './controllers';
Rails.start();

window.toastr = toastr;

$(document).ready(function () {
  $('.counter').counterUp({
    delay: 30,
    time: 1000,
  });

  if ($('.fade-effect').length) {
    console.log('fade effect');
    $('.fade-effect').fadeIn(2000);
  }

  if ($('.custom-progress').length) {
    $('.progress-value > span').each(function () {
      $(this)
        .prop('Counter', 0)
        .animate(
          {
            Counter: $(this).text(),
          },
          {
            duration: 1500,
            easing: 'swing',
            step: function (now) {
              $(this).text(Math.ceil(now));
            },
          }
        );
    });
  }

  if ($('.follow-icon').length) {
    $('.follow-icon a').on('click', function () {
      $('#new_coming_soon_subscription').attr('action', $(this).data('action'));
    });
  }

  if (
    window.location.hash === '#registration-form' &&
    $('#registration-form').length
  ) {
    var fixedNavBarPadding = 87;
    var offsetTop = $('#registration-form').offset().top - fixedNavBarPadding;
    $('html').scrollTop(offsetTop);
  }

  if ($('.format_number').length > 0) {
    const currencyInput = AutoNumeric.multiple('.format_number', {
      alwaysAllowDecimalCharacter: false,
      decimalPlaces: 0,
      digitGroupSeparator: ' ',
      minimumValue: 0,
    });
  }

  $('.auto-input').on('change', function () {
    var form = $(this).parents('form')[0];

    Rails.fire(form, 'submit');
  });
});

$(function () {
  $('[data-bs-toggle="tooltip"]').tooltip();
});
